import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dynamicStrikeLabelPipe',
})
export class DynamicStrikeLabelPipe implements PipeTransform {
  transform(upsideType: string, labels: any): string {
    return upsideType === 'DIGITAL'
      ? labels.payoff.participation.upside.strike
      : labels.payoff.participation.upside.callStrike;
  }
}
